import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, ValidationService, DataService } from 'app/services';
import { config, messages } from 'app/constants';

import { Subscription } from 'rxjs';
import { UpdateContactDialogComponent } from '../update-contact-dialog/update-contact-dialog.component';
import { phoneTypes } from 'app/constants/customer';
import { sortBy } from 'lodash';

@Component({
  selector: 'app-supplier-update',
  templateUrl: './supplier-update.component.html',
  styleUrls: ['./supplier-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class SupplierUpdateComponent implements OnInit, OnDestroy {
  @Input() supplier: any;
  @Input() paymentTerms: any[] = [];
  @Input() tags: any[] = [];
  @Input() index;

  @Output() supplierUpdate = new EventEmitter();

  @ViewChild('updateCustomerContainer', { static: true })
  updateCustomerContainer: ElementRef;

  isLandlineUnique: boolean = true;
  isZipCode1Valid: boolean = true;
  isZipCode2Valid: boolean = true;
  nameSuggestions: string[] = [];
  validate: any = {};
  focus = {
    notes: false,
  };
  addressCityResults: any;
  bAddressCityResults: any;
  internalSuppliersResults: any;
  addressCities = [];
  bAddressCities = [];
  allCities = [];
  customerTags: any[] = [];
  config = config;
  isCreateTagFieldVisible: boolean = false;
  isDataChange: boolean = false;
  customerAppointments: any;
  isDisplayNameChanged: boolean = false;
  isValidUrl = true;
  isSupplierDataValid: boolean = true;
  errors: any = {
    emails: {},
    phones: {},
  };

  dataServiceSub: Subscription;
  isProcessing: boolean = false;
  isAppleDevice: boolean = false;
  contact: any = {};
  supplierTypes: any[] = [
    {
      label: 'Internal',
      name: 'Internal',
      value: 'internal',
      icon: 'far fa-user',
      placeholder: 'Internal',
    },
    {
      label: 'Online ordering',
      name: 'Online ordering',
      value: 'online',
      icon: 'far fa-cars',
      placeholder: 'Online ordering',
    },
  ];
  isAccountPayablePayment: boolean = false;
  phoneTypes = phoneTypes;
  qboSupplierList: any = [];
  isTypeOnlie: boolean = false;
  selectedSupplierName: string = '';
  supplierRefObject: any = {};

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private validationService: ValidationService,
    private dataService: DataService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.isAppleDevice = this.helperService.isAppleDevice();
    this.dataServiceSub = this.dataService.getData().subscribe((obj) => {
      this.isAccountPayablePayment = this.dataService.accountPayablePayment;
      this.paymentTerms = this.dataService.accPayableTerms;
      if (obj.data.key === 'sidebar-supplier-update') {
        this.onSubmit();
      }
    });
    this.paymentTerms = this.dataService.accPayableTerms;
    this.isAccountPayablePayment = this.dataService.accountPayablePayment;
    if (this.paymentTerms.length) {
      this.paymentTerms.map((res) => {
        res.label = res.name;
        res.value = res._id;
      });
    }
    if (this.supplier.type.value === 'online' || this.supplier.type.value === 'sublet') {
      this.isTypeOnlie = true;
      this.getQboSupplierList();
      this.selectedSupplierName = this.supplier.quickbooksCompatibility.qboName;
      this.supplierRefObject = {
        _id: this.supplier.quickbooksCompatibility?.internalId,
        name: this.supplier.quickbooksCompatibility?.qboName,
        quickbooksCompatibility: this.supplier.quickbooksCompatibility,
      };
    }
  }
  getQboSupplierList() {
    this.httpService.getQBOSupplierList().then((res) => {
      if (res && res?.length) {
        this.qboSupplierList = res.map((item) => {
          return {
            ...item,
            label: item.name,
            value: item._id,
            name: item.name,
            _id: item._id,
          };
        });
        this.qboSupplierList = sortBy(this.qboSupplierList, 'supplierName');
      }
    });
  }
  ngOnDestroy() {
    if (this.dataServiceSub) {
      this.dataServiceSub.unsubscribe();
    }
  }

  craeteNewSupplier() {
    try {
      this.httpService
        .addNewQBOSupplier(this.supplier._id)
        .then((res) => {
          if (res) {
            this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: res.name }));
            this.helperService.showToaster('success', 'QBO Supplier Added');
          }
        })
        .catch((err) => {
          this.helperService.showToaster('error', err.Message);
        });
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }
  handleChange(type: string, event: any) {
    if (type === 'url' && event === '') {
      this.isValidUrl = true;
    }
    if (type === 'type') {
      if (event === 'online') {
        return;
      } else {
        this.supplier.type = this.supplierTypes[0];
        // this.supplier[type] = event;
      }
    }
    if (type === 'supplierName') {
      this.supplier.name = event;
    }

    if (type === 'phone' || type === 'phone2') {
      this.supplier[type] = this.helperService.removePhoneFormatting(event);
    } else if (type === 'wareHouseAddress-addLine1') {
      this.supplier.wareHouseAddress.addLine1 = event;
    } else if (type === 'billingAddress-addLine1') {
      this.supplier.billingAddress.addLine1 = event;
    } else if (type === 'wareHouseAddress-zip') {
      this.isZipCode1Valid = true;
      this.supplier.wareHouseAddress.zip = event;
    } else if (type === 'billingAddress-zip') {
      this.isZipCode2Valid = true;
      this.supplier.billingAddress.zip = event;
    } else {
      this.supplier[type] = event;
    }
  }

  handleFocus(name: string) {
    this.errors[name] = '';
    this.focus[name] = true;
  }

  /** check for uniqueness on blur of name, email, phone */
  handleBlur(name: string) {
    let value = this.supplier[name];
    // this.focus[name] = false;
    if (name === 'url') {
      if (value) {
        const isValid = this.validationService.validateURLWebsite(value);
        if (!isValid) {
          this.isValidUrl = false;
          this.validate[name] = messages.inValidURL;
        } else if (isValid) {
          this.isValidUrl = true;
          this.validate[name] = '';
        }
        this.isSupplierDataValid = isValid;
        return isValid;
      }
      return false;
    }

    if (!value) {
      this.validate[name] = messages.inValidURL;
    }
  }

  populateCityByZipCode(type: string) {
    this.addressCities = this.allCities;
    this.bAddressCities = this.allCities;
    let zip = '';

    if (type === 'address') {
      zip = this.supplier.address.zip;
      this.supplier.address.zip = this.validationService.formatZip(zip);
    } else {
      zip = this.supplier.businessAddress.zip;
      this.supplier.businessAddress.zip = this.validationService.formatZip(zip);
    }

    const formattedZip = this.helperService.removeSpaceFromString(zip).toUpperCase();

    this.httpService.getZip(formattedZip).then(
      (res) => {
        if (res) {
          this.isZipCode1Valid = true;
          this.isZipCode2Valid = true;
          this.supplier[type].city = res.city;
          this.supplier[type].state = res.state;
          this.supplier[type].stateCode = res.stateCode;
          this.supplier[type].country = res.country;
        } else {
          this.supplier[type].city = null;
          this.supplier[type].state = null;
          if (type === 'address') {
            this.errors.zip = 'Zip / Postal Code invalid';
            this.isZipCode1Valid = false;
          } else {
            this.errors.zip2 = 'Zip / Postal Code invalid';
            this.isZipCode2Valid = false;
          }
        }
      },
      (error) => {
        if (type === 'address') {
          this.isZipCode1Valid = false;
          this.errors.zip = 'Zip / Postal Code invalid';
        } else {
          this.isZipCode2Valid = false;
          this.errors.zip2 = 'Zip / Postal Code invalid';
        }
      },
    );
  }

  onAddressCitySearch(query: string = '', type: string) {
    if (query) {
      this.httpService.citySearch({ city: this.helperService.trimString(query) }).then(
        (cities) => {
          if (type === 'primary') {
            this.addressCityResults = cities;
          } else {
            this.bAddressCityResults = cities;
          }
        },
        (error) => {
          this.helperService.showToaster('error', this.helperService.getErrorMsg(error));
        },
      );
    }
  }

  onAddressClear(name: string) {
    if (name === 'primary') {
      this.bAddressCityResults = [];
    } else {
      this.addressCityResults = [];
    }
  }

  onInternalSupplierSearch(query: string = '') {
    const regex = new RegExp(query, 'i');
    this.internalSuppliersResults = this.qboSupplierList.filter((item) => regex.test(item.label));
    this.internalSuppliersResults = sortBy(this.internalSuppliersResults, 'supplierName');
  }

  onInternalSupplierClear() {
    this.selectedSupplierName = '';
    this.internalSuppliersResults = [...this.qboSupplierList];
  }

  showSuggestions(type?: string) {
    this.focus[type] = true;
  }

  selectSupplierRef($event) {
    this.selectedSupplierName = $event.name;
    this.supplierRefObject = $event;
  }

  getSupplierNames(): string[] {
    let supplierNames: string[];
    if (this.internalSuppliersResults) {
      supplierNames = this.internalSuppliersResults.map((supplier) => supplier);
    } else {
      supplierNames = this.qboSupplierList.map((supplier) => supplier);
    }
    // const sortedSupplierNames = supplierNames.sort((a, b) => a.localeCompare(b));
    return supplierNames;
  }

  onClearCity(type: string) {
    this.supplier[type].city = '';
    this.supplier[type].state = '';
    this.supplier[type].zip = '';
    this.supplier[type].country = '';
    this.supplier[type].stateCode = '';
  }

  onAddressCitySelect(event: any) {
    this.supplier.wareHouseAddress.city = event.city;
    this.supplier.wareHouseAddress.state = event.state;
    this.supplier.wareHouseAddress.stateCode = event.stateCode;
    this.supplier.wareHouseAddress.country = event.country;
  }

  renderCityName(city: string, stateCode: string) {
    if (city && stateCode) {
      return `${city}, ${stateCode}`;
    }

    return `${city || ''}`;
  }

  validation(): Boolean {
    let isFormValid = true;

    this.validate = {};
    this.errors = {
      emails: {},
      phones: {},
    };

    if (this.supplier.emails && this.supplier.emails.length) {
      const emails = [];
      this.supplier.emails.forEach((email: any, index: number) => {
        this.errors.emails[index] = {};

        if (emails.includes(email.value)) {
          this.errors.emails[index].value = `Add a unique email`;
          isFormValid = false;
        }

        if (email.value) {
          if (email.value && !this.validationService.validateEmail(email.value)) {
            this.errors.emails[index].value = 'Email is not valid';
            isFormValid = false;
          }

          emails.push(email.value);
        }
      });
    }
    if (this.supplier.phones && this.supplier.phones.length) {
      const phones = [];

      this.supplier.phones.forEach((phone: any, index: number) => {
        this.errors.phones[index] = {};
        phone.value = this.helperService.removePhoneFormatting(phone.value);

        if (phones.includes(phone.value)) {
          this.errors.phones[index].value = `Add a unique number`;
          isFormValid = false;
        }

        if (phone.value) {
          if ((phone.value || '').length < 10) {
            this.errors.phones[index].value = `Phone is not valid`;
            isFormValid = false;
          }

          phones.push(phone.value);
        }
      });
    }
    if (!this.isValidUrl) {
      this.validate.url = messages.inValidURL;
    }
    this.supplier.supplierName = this.supplier.supplierName?.trim()
    if (!this.supplier.supplierName) {
      this.validate.supplierName = 'Supplier name is required';
    }

    if (!this.supplier.name) {
      this.validate.name = 'Display name is required';
    }

    if (!this.isZipCode1Valid) {
      this.validate.zip = 'Zip / Postal code is invalid';
    }

    if (!this.isZipCode2Valid) {
      this.validate.zip2 = 'Zip / Postal code is invalid';
    }

    const isValid = isFormValid && this.isZipCode1Valid && this.isZipCode2Valid && this.supplier.name && this.supplier.supplierName && this.isValidUrl;
    return isValid;
  }

  formatSupplierData(data: any) {
    const supplier = { ...data };
    supplier.type = supplier.type.value;
    if (supplier.type === 'online' || supplier.type === 'sublet') {
      supplier.quickbooksCompatibility = {
        // qboResponse: supplier.qboResponse,
        qboId: this.supplierRefObject?.quickbooksCompatibility?.qboId ? this.supplierRefObject?.quickbooksCompatibility?.qboId : null,
        internalId: this.supplierRefObject._id,
        qboName: this.supplierRefObject?.name,
      };
    }
    return supplier;
  }

  mapSupplierContactTypes() {
    this.supplier.emails && this.supplier.emails.map((x) => (x.contactType = x.contactType.value ? x.contactType.value : x.contactType));
    this.supplier.phones && this.supplier.phones.map((x) => (x.contactType = x.contactType.value ? x.contactType.value : x.contactType));
  }
  handleUpdateSupplier() {
    this.isProcessing = true;
    this.mapSupplierContactTypes();
    this.httpService.updateSupplier(this.formatSupplierData(this.supplier)).then(
      (supplier: any) => {
        if (supplier) {
          this.isProcessing = false;
          this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: this.supplier.name }));
          this.helperService.showToaster('success', 'Supplier updated');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err.messages);
      },
    );
  }

  onSubmit() {
    if (this.validation()) {
      this.handleUpdateSupplier();
    }
  }

  openContactUpdateDialog() {
    const primaryEmail = (this.supplier.email && this.supplier.email[0]) || { value: '' };
    const primaryPhone = (this.supplier.phone && this.supplier.phone[0]) || { value: '' };
    const ref = this.dialogService.open(UpdateContactDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        contactEntityType: 'supplier',
        contactEntityId: this.supplier._id,
        email: primaryEmail.value,
        phone: primaryPhone.value,
        isSupplier: true,
        contact: this.supplier.contactId,
        supplierData: this.supplier,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.getCustomerContacts();
        this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: this.supplier.name }));
      }
      onClose.unsubscribe();
    });
  }

  getCustomerContacts() {
    if (!this.supplier._id) return;

    this.httpService.getContactInfo(this.supplier._id, false, { contactEntityType: 'supplier' }).then(
      (contact) => {
        this.contact = contact;
        this.supplierUpdate.emit({
          contact,
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  scrollToTop(scrollHeight: any) {
    setTimeout(() => {
      try {
        this.updateCustomerContainer.nativeElement.scrollTop = scrollHeight;
      } catch (err) {}
    }, 100);
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.updateCustomerContainer.nativeElement.scrollTop = this.updateCustomerContainer.nativeElement.scrollHeight + 18;
      } catch (err) {}
    }, 100);
  }

  handleMultiFocus(type: string, key: string, index: number, focus: boolean) {
    if (!focus) {
      this.handleDisableContactPref();
    }
  }

  handleDisableContactPref() {
    if (this.supplier.emails && this.supplier.emails.length) {
      for (let i = 0; i < this.supplier.emails.length; i++) {
        const email = this.supplier.emails[i];

        if (email.isActive && email.isPrimary && this.validationService.validateEmail(email.value)) {
          // this.isEmailDisabled = false;
        }
      }

      // if (this.isEmailDisabled) {
      //   this.contactOnEmail = false;
      // }
    }

    if (this.supplier.phones && this.supplier.phones.length) {
      for (let i = 0; i < this.supplier.phones.length; i++) {
        const phone = this.supplier.phones[i];

        if (phone.isActive && phone.isPrimary && this.helperService.removePhoneFormatting(phone.value).length >= 10) {
          // this.isPhoneDisabled = false;
        }
      }

      // if (this.isPhoneDisabled) {
      //   this.contactOnPhone = false;
      // }
    }
  }

  handleMultiChange(type: string, key: string, index: number, value: any) {
    this.supplier[type][index][key] = value;

    if (value && type === 'phones' && key === 'contactType') {
      if (value.value === 'landline') {
        this.supplier.phones[index].isPrimary = false;
      }

      if (!this.supplier.phones.filter(({ isPrimary }) => isPrimary).length) {
        for (let i = 0; i < this.supplier.phones.length; i++) {
          const { isActive, contactType } = this.supplier.phones[i];

          if (isActive && contactType && contactType.value === 'mobile') {
            this.supplier.phones[i].isPrimary = true;
            break;
          }
        }
      }
    } else if (key === 'isPrimary') {
      this.supplier[type].forEach((contact: any, i: number) => {
        if (index !== i) {
          this.supplier[type][i].isPrimary = false;
        }
      });
    }
  }

  onAddressCityClear() {
    this.addressCityResults = [];
    this.supplier.wareHouseAddress.city = null;
  }

  zipChange(event: any, type: string) {
    if (!event) {
      return;
    }

    this.addressCities = this.allCities;
    this.bAddressCities = this.allCities;

    if (type === 'wareHouseAddress') {
      this.supplier.wareHouseAddress.zip = this.validationService.formatZip(event);
    } else {
      this.supplier.billingAddress.zip = this.validationService.formatZip(event);
    }

    const formattedZip = this.helperService.removeSpaceFromString(event).toUpperCase();

    this.httpService.getZip(formattedZip).then(
      (res) => {
        if (res) {
          this.supplier[type].city = res.city;
          this.supplier[type].state = res.state;
          this.supplier[type].stateCode = res.stateCode;
          this.supplier[type].country = res.country;

          if (type === 'wareHouseAddress') {
            this.isZipCode1Valid = true;
          }

          if (type === 'billingAddress') {
            this.isZipCode2Valid = true;
          }
        } else {
          if (type === 'wareHouseAddress') {
            this.supplier[type].city = null;
            this.supplier[type].state = null;
            this.isZipCode1Valid = false;
            this.validate.zip = 'Zip / Postal code is invalid';
          }

          if (type === 'billingAddress') {
            this.supplier[type].city = null;
            this.supplier[type].state = null;
            this.isZipCode2Valid = false;
            this.validate.zip2 = 'Zip / Postal code is invalid';
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  addressCitySearch(event: string) {
    const query = { city: this.helperService.trimString(event) };
    if (query) {
      this.httpService.citySearch(query).then(
        (cities) => {
          this.addressCityResults = cities;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onBaddressCityClear() {
    this.bAddressCityResults = [];
    this.supplier.billingAddress.city = null;
  }

  bAddressCitySearch(event: any) {
    const query = { city: this.helperService.trimString(event) };

    if (query) {
      this.httpService.citySearch(query).then(
        (cities) => {
          this.bAddressCityResults = cities;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onBaddressCitySelect(event: any) {
    this.supplier.billingAddress.city = event.city;
    this.supplier.billingAddress.state = event.state;
    this.supplier.billingAddress.stateCode = event.stateCode;
    this.supplier.billingAddress.country = event.country;
  }
}
